import { useContext, useState } from "react";
import { useForm, SubmitHandler } from "react-hook-form";

//import hooy useSession
import { useSession } from "../hooks/useSession";
import { zodResolver } from "@hookform/resolvers/zod";
import { toast, ToastContainer } from "react-toastify";
import { userSchema_login } from "../validations/userSchema_login"; //mappedPlans
import { AuthContext } from '../context/authContext';

import { Input, Label, Button } from "../components/ui";


export const LoginPage = () => {

	const auth = useContext(AuthContext)
	const { user, token, role } = useContext(AuthContext)

	const { login } = useSession();

	const [showPassword, setShowPassword] = useState(false);
	const [loading, setLoading] = useState(false);
	const { register, handleSubmit, watch, formState: { errors }, } = useForm({
		resolver: zodResolver(userSchema_login)
	});

	const onSubmit = async (data) => {
		//console.log(data);
		setLoading(true);

		try {

			/*const response = await fetch(
				`/api/authentication/login`, // #Df1 ---> Ver mail Dockerizacion SUBSE
				{
					method: "POST",
					headers: {
						"Content-type": "application/json"
					},
					body: JSON.stringify(data)
				}
			);*/
			const response = await login(data);// { username, password }
			console.log("RESPONSE=>", response)

			//const parseRes = await response.json();
			//toast.success(`Logged ISS Successfully`);

				if (response.success) {
				toast.success(`Logged Successfully`);
			} else {
				// El mensaje del backend ya distingue los 3 estados de users.validez
				// (sin validar / dado de baja / otro error). Antes se pisaba con un
				// texto fijo siempre que el mensaje dijera "verificación" o
				// "pendiente", y un usuario dado de baja veía que le pedían esperar
				// una confirmación que nunca iba a llegar.
				const msg = response.error || 'Error al conectar. Por favor vuelva a intentarlo';
				if (msg.includes('verificación') || msg.includes('pendiente')) {
					toast.warn(msg);
				} else if (msg.includes('baja') || msg.includes('desactivad')) {
					toast.error(msg);
				} else {
					toast.error(msg);
				}
			}

		} catch (err) {
			toast.error(`Error al conectar. Por favor vuelva a intentarlo`);

		} finally {
			setLoading(false);
		}

	};
	const iconColorClass = showPassword
		? 'text-blue-400 hover:text-blue-600'  // Azul cuando está abierto (Mostrando)
		: 'text-blue-400 hover:text-blue-600'; // Gris cuando está cerrado (Oculto)

	const BaseEyePaths = (
		<>
			{/* Paths del ojo abierto y el iris */}
			<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
			<circle cx="12" cy="12" r="3"></circle>
		</>
	);
	// ----------------------------------------------------------------------
	// 👁️ SVG del Ojo Abierto (Mostrar Contraseña)
	// ----------------------------------------------------------------------
	const EyeIcon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			className="w-6 h-6" // Tamaño del SVG con Tailwind
		>
			{BaseEyePaths}
		</svg>
	);

	// ----------------------------------------------------------------------
	// 🚫 SVG del Ojo Tachado (Ocultar Contraseña)
	// ----------------------------------------------------------------------
	const EyeSlashIcon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			className="w-6 h-6"
		>
			{BaseEyePaths}
			{/* 💥 EL DETALLE: La línea diagonal que cruza el ojo */}
			{/* La línea va de la esquina superior izquierda a la inferior derecha */}
			<line x1="1" y1="1" x2="23" y2="23" strokeWidth="2.5" />
		</svg>
	);

	return (
		<>
			<div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">

				<div className="sm:mx-auto sm:w-full sm:max-w-sm">
					{/*<img
                    className="mx-auto h-10 w-auto"
                    src="https://tailwindui.com/img/logos/mark.svg?color=indigo&shade=600"
                    alt="Your Company" 
                    /> */}
					<h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900 dark:text-white">
						Ingreso de usuarios
					</h2>
				</div>

				<div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
					<form className="space-y-6" onSubmit={handleSubmit(onSubmit)}>

						<div>
							<Label htmlFor="email">Email Address</Label>
							<div className="mt-2">
								<Input
									id="email"
									type="email"
									placeholder='correo@gmail.com'
									required
									{...register("email")}
								/>
							</div>
						</div>

						<div>
							<div className="flex items-center justify-between">
								<Label htmlFor="password">Password</Label>
								<div className="text-sm">
									<a href="#" className="font-semibold text-indigo-600 hover:text-indigo-500">
										Forgot password?
									</a>
								</div>
							</div>
							<div className="mt-2" style={{ position: 'relative' }}>
								<Input
									id="password"
									type={showPassword ? "text" : "password"}
									placeholder="********"
									required
									{...register("password")}
								/>
								<button
									type="button"
									onClick={() => setShowPassword(!showPassword)}
									// Agregamos el tamaño del icono con text-xl para una buena visualización
									className={`absolute inset-y-0 right-0 flex items-center pr-3 text-xl leading-none cursor-pointer focus:outline-none ${iconColorClass}`}
									aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
								>
									{/* Renderiza el SVG apropiado */}
									{showPassword ? EyeSlashIcon : EyeIcon}
								</button>
							</div>
						</div>

						<Button type="submit" disabled={loading}>
							{loading ? (
								<svg className="animate-spin -ml-1 mr-2 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
									<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
									<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
								</svg>
							) : 'Ingresar'}
						</Button>
					</form>
				</div>
				<ToastContainer />
			</div>
		</>
	)
}
